import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Tournament name"),
  startAt: Yup.date().nullable().label("Start Date"),
  endAt: Yup.date().nullable().label("End Date"),
  minLegs: Yup.number().nullable().integer().min(1).label("Min Legs"),
  maxLegs: Yup.number().nullable().integer().min(1).label("Max Legs"),
  minOddPerBet: Yup.number().nullable().min(1).label("Min Odd Per Bet"),
  minTotalOdd: Yup.number().nullable().min(1).label("Min Total Odd"),
  maxTotalOdd: Yup.number().nullable().min(1).label("Max Total Odd"),
  minCouponsToRank: Yup.number().nullable().integer().min(0).label("Min Coupons To Rank"),
  maxCouponsPerDay: Yup.number().nullable().integer().min(1).label("Max Coupons Per Day"),
});

const Inputs = [
  {
    name: "name",
    label: "Name",
    type: "text",
    value: "single",
    valueAttr: "name",
    required: true,
    customClass: "col-md-6",
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    value: "single",
    valueAttr: "isActive",
    defaultValue: () => true,
    customClass: "col-md-6",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    value: "single",
    valueAttr: "description",
    customClass: "col-md-12",
  },
  {
    name: "sponsorId",
    label: "Sponsor",
    type: "select",
    value: "single",
    valueAttr: "sponsorId",
    customClass: "col-md-12",
  },
  {
    name: "prizesDescription",
    label: "Prizes Description (summary label e.g. '25,000 PRIZE')",
    type: "text",
    value: "single",
    valueAttr: "prizesDescription",
    customClass: "col-md-9",
  },
  {
    name: "coins",
    label: "Entry Cost (coins)",
    type: "text",
    value: "single",
    valueAttr: "coins",
    customClass: "col-md-3",
    defaultValue: () => 0,
  },
  {
    name: "startAt",
    label: "Start Date",
    type: "date",
    value: "single",
    valueAttr: "startAt",
    customClass: "col-md-6",
  },
  {
    name: "endAt",
    label: "End Date",
    type: "date",
    value: "single",
    valueAttr: "endAt",
    customClass: "col-md-6",
  },
  {
    name: "leagueId",
    label: "League (leave empty for open tournament)",
    type: "select",
    value: "single",
    valueAttr: "leagueId",
    customClass: "col-md-6",
  },
  {
    name: "countryIds",
    label: "Available Countries (leave empty = all)",
    type: "select",
    value: "multiple",
    valueAttr: "countryIds",
    enableOrder: false,
    customClass: "col-md-6",
  },
  {
    name: "excludeCountryIds",
    label: "Exclude Countries (never shown to these countries)",
    type: "select",
    value: "multiple",
    valueAttr: "excludeCountryIds",
    enableOrder: false,
    customClass: "col-md-6",
  },
  {
    name: "countrySponsors",
    label: "Sponsor per country (overrides the default Sponsor for viewers of that country)",
    type: "nestedArray",
    value: "multiple",
    valueAttr: "countrySponsors",
    collapsible: true,
    summaryFn: (row: any) => (row.countryId && row.sponsorId ? `Country ${row.countryId} → Sponsor ${row.sponsorId}` : "Country sponsor"),
    columns: [
      {
        name: "countryId",
        label: "Country",
        type: "select",
        value: "single",
        valueAttr: "countryId",
        relationshipName: "countryIds",
        required: true,
      },
      {
        name: "sponsorId",
        label: "Sponsor",
        type: "select",
        value: "single",
        valueAttr: "sponsorId",
        relationshipName: "sponsorId",
        required: true,
      },
    ],
  },
  {
    name: "minLegs",
    label: "Min Legs",
    type: "text",
    value: "single",
    valueAttr: "minLegs",
    customClass: "col-md-3",
  },
  {
    name: "maxLegs",
    label: "Max Legs",
    type: "text",
    value: "single",
    valueAttr: "maxLegs",
    customClass: "col-md-3",
  },
  {
    name: "minOddPerBet",
    label: "Min Odd Per Bet",
    type: "text",
    value: "single",
    valueAttr: "minOddPerBet",
    customClass: "col-md-3",
  },
  {
    name: "minTotalOdd",
    label: "Min Total Odd",
    type: "text",
    value: "single",
    valueAttr: "minTotalOdd",
    customClass: "col-md-3",
  },
  {
    name: "maxTotalOdd",
    label: "Max Total Odd",
    type: "text",
    value: "single",
    valueAttr: "maxTotalOdd",
    customClass: "col-md-4",
  },
  {
    name: "minCouponsToRank",
    label: "Min Coupons To Rank",
    type: "text",
    value: "single",
    valueAttr: "minCouponsToRank",
    customClass: "col-md-4",
  },
  {
    name: "maxCouponsPerDay",
    label: "Max Coupons Per Day",
    type: "text",
    value: "single",
    valueAttr: "maxCouponsPerDay",
    customClass: "col-md-4",
  },
  {
    name: "prizes",
    label: "Prizes",
    type: "nestedArray",
    value: "multiple",
    valueAttr: "prizes",
    columns: [
      { name: "rankFrom", label: "Rank From", type: "text", required: true },
      { name: "rankTo", label: "Rank To", type: "text", required: true },
      { name: "coins", label: "Coins", type: "text" },
      { name: "description", label: "Description", type: "text" },
      { name: "iconUrl", label: "Icon URL", type: "text" },
      { name: "order", label: "Order", type: "text", required: true },
    ],
  },
  {
    name: "rules",
    label: "Rules",
    type: "nestedArray",
    value: "multiple",
    valueAttr: "rules",
    columns: [
      { name: "order", label: "Order", type: "text", required: true },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea", required: true },
    ],
  },
  {
    name: "termsAndConditions",
    label: "Terms & Conditions",
    type: "htmlEditor",
    value: "single",
    valueAttr: "termsAndConditions",
    customClass: "col-md-12",
    placeholder: "Write the tournament terms and conditions...",
  },
];

export { Inputs, validationSchema };
